import React, { useEffect } from "react";
import Routes from "./routes";
import Spin from "./_lib/spin/spin";

import "react-awesome-lightbox/build/style.css";
import "../../assets/scss/dashboard.scss";

const App = (props) => {
  // if (loading) return <Spin />;
  useEffect(() => {
    document.documentElement.setAttribute('lang', 'fa-IR')
  }, [])
  return (
    <>
      <div id="wrapper">
        <Routes />
      </div>
      <div id="ajax-loading">
        در حال ارسال/دریافت اطلاعات، لطفا منتظر باشید ...
      </div>
    </>
  );
};

export default App;
